import { useApolloClient } from '@apollo/client'
import type { InFilterDefinition } from '@factorialco/f0-react'
import { EmployeeWorkplacesFilterDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const useWorkplaceFilter = (): InFilterDefinition<number> => {
  const client = useApolloClient()

  return {
    label: i18n.t('employees.employees_list.headers.workplace'),
    type: 'in' as const,
    options: {
      cache: true,
      options: async () => {
        const { data } = await client.query({
          query: EmployeeWorkplacesFilterDocument,
          fetchPolicy: 'cache-first',
        })

        return data.locations.locations.map((location) => ({
          label: location.name,
          value: location.id,
        }))
      },
    },
  }
}
